<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-file-alt">
      <translate>Shipment Orders</translate>
    </page-title>

    <api-list type="shippingOrders" :model="models.shippingOrders" :quick-filters="quickFiltersSetup.shippingOrders" :pre-filters="[['status', 'in', ['draft', 'pending'], true]]" />

  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ShippingOrdersList',
  title() {
    return this.$gettext('Shipment Orders')
  },
  components: {
    ApiList
  },
  props: {
    type: {
      type: String,
      default: 'shippingOrders'
    }
  }
}
</script>
